export default __webpack_public_path__ + "static/ETHH-24541c2a8acd92fe157438324386c672.png";